import { BackupLevel } from '../api';

import { SurgeToastMessage } from '@/routes/Agency/PaySurge/components/SurgeToast';

const SCOPE: Record<BackupLevel, string> = {
  client: 'every job of this client',
  order: 'every job in this order',
  job: 'this job',
};

const PARENT: Partial<Record<BackupLevel, string>> = {
  job: 'order',
  order: 'client',
};

/**
 * The confirmation after a save, in the toast the surge pay screens use (the
 * app has no toast service of its own on these pages).
 */
export const backupSavedToast = (
  level: BackupLevel,
  enabled: boolean | null,
  nowOn: boolean,
): SurgeToastMessage => {
  const kind = nowOn ? 'on' : 'off';
  if (enabled === null) {
    return {
      kind,
      title: `Following the ${PARENT[level]}’s setting`,
      message: `Auto backups are ${nowOn ? 'on' : 'off'} for ${SCOPE[level]}.`,
    };
  }
  return {
    kind,
    title: `Auto backups turned ${nowOn ? 'on' : 'off'}`,
    message: nowOn
      ? `For ${SCOPE[level]}.`
      : `No automatic backup invites, and nobody will be hired from standby on ${SCOPE[level].replace('every', 'any')}.`,
  };
};
